import React from 'react';
import { motion } from 'framer-motion';
import { FaMobileAlt, FaLock, FaMagic, FaUserShield, FaHeart, FaComments } from 'react-icons/fa';

const FeaturesSection = () => {
  const features = [
    {
      icon: FaMagic,
      title: "AI-Powered Matching",
      desc: "Our advanced algorithms analyze millions of data points to find your most compatible partner.",
      color: "text-purple-600",
      bg: "bg-purple-100"
    },
    {
      icon: FaUserShield,
      title: "100% Verified Profiles",
      desc: "Every profile is manually screened and verified with Government ID to ensure safety.",
      color: "text-blue-600",
      bg: "bg-blue-100"
    },
    {
      icon: FaLock,
      title: "Privacy Control",
      desc: "You have complete control over who sees your photos and contact information.",
      color: "text-green-600",
      bg: "bg-green-100"
    },
    {
      icon: FaComments,
      title: "Secure Chat",
      desc: "Connect safely with our built-in secure chat and video calling features.",
      color: "text-rose-600",
      bg: "bg-rose-100"
    },
    {
      icon: FaHeart,
      title: "Interest Based Matching",
      desc: "Connect with people who share your hobbies, passions, and lifestyle.",
      color: "text-red-600",
      bg: "bg-red-100"
    },
    {
      icon: FaMobileAlt,
      title: "User Friendly App",
      desc: "Stay connected on the go with our top-rated mobile application.",
      color: "text-orange-600",
      bg: "bg-orange-100"
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-rose-600 font-bold tracking-wider uppercase text-sm">Why Choose Us</span>
          <h2 className="text-4xl font-black text-gray-900 mt-2 mb-4">Everything you need to find your <span className="text-rose-600">perfect match</span></h2>
          <p className="text-gray-600 text-lg">We have designed our platform with one goal in mind: to help you find your life partner in the safest, most convenient way possible.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 group"
            >
              <div className={`w-14 h-14 ${feature.bg} ${feature.color} rounded-2xl flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform`}>
                <feature.icon />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
